import { getWordsCount } from '~/helpers/functions';
import { LoadingService } from '~/services/LoadingService';

import type { LoadingConfig, LoadingServiceParams } from './types';
import { RequestLang } from './types';

export class AIDetectorLoadingService extends LoadingService<
  LoadingConfig[],
  LoadingServiceParams
> {
  constructor(config: LoadingConfig[]) {
    super(config);
  }

  getLoadingTime(params: LoadingServiceParams): number {
    const { requestText, requestLang } = params;
    const wordsCount = getWordsCount(requestText);
    const config = this.config.find((cfg) =>
      cfg.condition(requestLang as RequestLang),
    );

    if (!config) {
      return 0;
    }

    return config.timeFunction(wordsCount);
  }
}
